var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccount = function SvgIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    d: "M16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5v-3.192c0-.426-.157-.838-.443-1.158a1.77 1.77 0 0 0-1.106-.58L16 15.255a31.5 31.5 0 0 0-8 0l-2.45.315a1.77 1.77 0 0 0-1.107.58c-.285.32-.443.732-.443 1.158V20.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    d: "M20 20.5v-3.192c0-.426-.157-.838-.443-1.158a1.77 1.77 0 0 0-1.106-.58L16 15.255a31.5 31.5 0 0 0-8 0l-2.45.315a1.77 1.77 0 0 0-1.107.58c-.285.32-.443.732-.443 1.158V20.5",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM20 20.5v-3.192c0-.426-.157-.838-.443-1.158a1.77 1.77 0 0 0-1.106-.58L16 15.255a31.5 31.5 0 0 0-8 0l-2.45.315a1.77 1.77 0 0 0-1.107.58c-.285.32-.443.732-.443 1.158V20.5",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.016H4v1.494h16v-1.494Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h18v19H3z"
  })))));
};
export default SvgIconAccount;